<template>
  <Modal :id="id" :title="modalTitle" :hideClose="true">
    <div slot="body" class="modal-body modal-form">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <Field
              type="text"
              name="name"
              label="Series Name"
              v-model="series.name"
              validate="required"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <Field
              type="select"
              name="discount_type"
              label="Discount Type"
              v-model="series.discount_type"
              :options="discountTypes"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <Field
              type="text"
              name="discount_amount"
              label="Discount Amount"
              v-model="series.discount_amount"
            />
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-success" href="#" @click.prevent="save">Save</a>
      <a class="btn btn-info" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "edit-series-modal",
      error: null,
      series: {
        id: null,
        name: "",
        discount_type: null,
        discount_amount: null
      }
    };
  },
  computed: {
    modalTitle() {
      return !!this.series.id ? "Edit Series" : "Add New Series";
    },
    discountTypes() {
      return [
        { label: "Fixed Amount", value: this.$root.constants.FIXED_DISCOUNT },
        { label: "% of Subtotal", value: this.$root.constants.PERCENT_DISCOUNT }
      ];
    }
  },
  methods: {
    save() {
      if (!this.series.name) {
        alert("Please enter a name for the series before continuing.");
        return;
      }
      this.resolve(this.series);
    }
  },
  mounted() {
    this.series = _.clone(this.options.series);
  }
};
</script>